import React from 'react';
import { Box, Typography } from '@mui/material';

function AgreementAcceptedAdditionalInfo({ responses = [] }) {
  if (!responses.length) return null;

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5, color: 'text.secondary' }}>
        Additional information
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {responses.map((entry) => (
          <Box key={entry.name}>
            <Typography variant="body2" fontWeight={600}>
              {entry.label || entry.name}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'pre-wrap' }}>
              {entry.value}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default AgreementAcceptedAdditionalInfo;
